
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    attachLeft: {
        borderTopLeftRadius: '0px',
        borderBottomLeftRadius: '0px'
    },
    attachRight: {
        marginRight: 0,
        borderTopRightRadius: '0px',
        borderBottomRightRadius: '0px',
        borderRight: '0px'
    },
    badgeContainer: {
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        lineHeight: '20px',
        letterSpacing: '0.4px',
        paddingTop: '0px',
        paddingBottom: '0px',
        color: '#ffffff',
        backgroundColor: '#00c8ff',
        borderRadius: '10px',
        display: 'inline-block',
        height: '20px',
        textAlign: 'center',
        width: '20px'
    },
    button: {
        border: '1px solid #D8D8D8',
        background: '#FFFFFF',
        height: '32px',
        padding: '0 12px',
        color: '#484848',
        marginRight: '10px',
        borderRadius: '4px',
        outline: 'none'
    },
    button_checked: {
        border: '1px solid #D8D8D8',
        background: '#00C8FF',
        height: '32px',
        padding: '0 12px',
        color: '#FFFFFF',
        marginRight: '10px',
        borderRadius: '4px',
        outline: 'none'
    },
    buttonScrollCover: {
        left: '0px',
        top: '0px',
        bottom: '0px',
        width: '24px',
        background: 'white',
        position: 'absolute',
        zIndex: 1
    },
    fakeFiltersButton: {
        opacity: 0,
        marginLeft: '8px'
    },
    filterRow: {
        paddingLeft: '8px',
        paddingTop: '8px',
        background: '#ffffff',
        position: 'fixed',
        top: '124px',
        height: '48px',
        lineHeight: 1,
        width: '100%',
        zIndex: 10
    },
    filterText: {
        marginRight: '10px'
    },
    moreFiltersButton: {
        position: 'absolute',
        marginLeft: '8px',
        left: '0px',
        zIndex: 1
    },
    scrollRegion: {
        position: 'absolute',
        left: '0px',
        right: '0px',
        overflowX: 'scroll',
        whiteSpace: 'nowrap'
    },
    spacing: {
        height: '48px'
    },
    textSpan: {
        marginRight: '10px'
    },
    wrapper: {
        display: 'inline-block',
        verticalAlign: 'middle'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/MobileFilterBar/styles.js